export default __webpack_public_path__ + "static/media/TorpedoClosed.c2a81e64.jpg";